import { forwardRef } from "react";
import { Sparkles } from "lucide-react";
import { DOCK_LABELS } from "../../shared/constants/pageAgentLabels";

interface AgentLauncherProps {
  /** False when the thread routes answered 404: the dock has nothing to open, so it renders nothing. */
  available: boolean;
  open: boolean;
  onOpen: () => void;
}

/** The floating button in the bottom-right corner that opens the dock. */
export const AgentLauncher = forwardRef<HTMLButtonElement, AgentLauncherProps>(
  function AgentLauncher({ available, open, onOpen }, ref) {
    if (!available) return null;
    return (
      <button ref={ref} type="button" className="pa-launcher" aria-haspopup="dialog" aria-expanded={open}
        onClick={onOpen}>
        <Sparkles aria-hidden="true" className="pa-launcher-icon" />
        <span className="pa-visually-hidden">{DOCK_LABELS.open}</span>
      </button>
    );
  });
